import Vue from 'vue'
import {
  FormSelectPlugin, FormRadioPlugin, FormCheckboxPlugin, DropdownPlugin, ButtonGroupPlugin, ToastPlugin, ModalPlugin, TablePlugin, CardPlugin, PaginationPlugin, BadgePlugin, ButtonPlugin, SidebarPlugin, FormDatepickerPlugin, LayoutPlugin, FormPlugin, FormInputPlugin, SpinnerPlugin, OverlayPlugin, InputGroupPlugin, ListGroupPlugin,
} from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import vSelect from 'vue-select'
import VueSweetalert2 from 'vue-sweetalert2'
import moment from 'moment'
import VueSignaturePad from 'vue-signature-pad'
import Tawk from 'vue-tawk'
import VueClipboard from 'vue-clipboard2'
import VueProgressBar from 'vue-progressbar'
import router from './router'
import store from './store'
import pusher from './pusherInstance'

import App from './App.vue'

// import VueFab from 'vue-float-action-button'

// Global Components
import './global-components'
// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/axios'

import 'vue-select/dist/vue-select.css'

// Mixinx

import permission from './@core/mixins/ui/permission'

import 'moment-timezone'
// import i18n from '@/libs/i18n'

// For more options see below

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(TablePlugin)
Vue.use(CardPlugin)
Vue.use(PaginationPlugin)
Vue.use(BadgePlugin)
Vue.use(ButtonPlugin)
Vue.use(SidebarPlugin)
Vue.use(FormDatepickerPlugin)
Vue.use(LayoutPlugin)
Vue.use(FormPlugin)
Vue.use(FormInputPlugin)
Vue.use(SpinnerPlugin)
Vue.use(OverlayPlugin)
Vue.use(ButtonGroupPlugin)
Vue.use(DropdownPlugin)
Vue.use(FormCheckboxPlugin)
Vue.use(FormRadioPlugin)
Vue.use(VueSweetalert2)
Vue.use(InputGroupPlugin)
Vue.use(FormSelectPlugin)
Vue.use(ListGroupPlugin)
Vue.use(VueSignaturePad)
Vue.component('v-select', vSelect)
Vue.use(VueClipboard)
// Vue.use(VueFab)
// Composition API
Vue.use(VueCompositionAPI)


// TAWK Chat Plugin
const tawkSrc = process.env.MIX_APP_TAWK_SRC
console.log(process.env.MIX_APP_ENV)
if (tawkSrc && process.env.MIX_APP_ENV === 'production') {
  Vue.use(Tawk, {
    tawkSrc,
  })
}


// UI options for vue loader. It basically shows a progress bar to indicate the loading progress of a route/component
const options = {
  color: '#7367f0',
  failedColor: 'red',
  thickness: '5px',
  transition: {
    speed: '0.2s',
    opacity: '0.6s',
    termination: 300
  },
  autoRevert: true,
  inverse: false
}

Vue.use(VueProgressBar, options)




require('@core/assets/fonts/feather/iconfont.css') // For form-wizard


// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.mixin(permission)
Vue.prototype.moment = moment
Vue.prototype.pusher = pusher
Vue.config.productionTip = false


new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
